const defaultState = null;

const RESET = 'session/createJobAndOrderRequest/RESET' as const;
const UPDATE = 'session/createJobAndOrderRequest/UPDATE' as const;

type CreateJobAndOrderRequest = {
  idempotencyKey: string;
  request: Promise<{
    orderId: string | undefined;
    jobId: string;
    revisionId: string;
    error?: unknown;
  } | null>;
};

type ResetAction = {
  type: 'session/createJobAndOrderRequest/RESET';
};

type UpdateAction = {
  type: 'session/createJobAndOrderRequest/UPDATE';
  value: CreateJobAndOrderRequest;
};

export const actionResetCreateJobAndOrderRequest = () => ({
  type: RESET,
});

export const actionUpdateCreateJobAndOrderRequest = (
  value: CreateJobAndOrderRequest,
) => ({
  type: UPDATE,
  value,
});

export default (
  state: CreateJobAndOrderRequest | null = defaultState,
  action: ResetAction | UpdateAction,
): CreateJobAndOrderRequest | null => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
